// extracted by mini-css-extract-plugin
module.exports = {"validationMessage":"_2wyC1RzR"};